import React, {useContext} from "react";

export const RootWindowContext = React.createContext<Window | null>(null);

export function useRootWindow () {
    return useContext(RootWindowContext);
}